import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import CustomTemplate from '../customtemplate/customtemplate.jsx';
import './infowindow.scss';

const LocationInfoWindow = (props) => {
  const { location } = props;
  const roundedDistance = location.distance.toFixed(2);
  const distanceUnit = 'mi';
  const todayDayName = i18n.t('DaysOfTheWeek', { returnObjects: true })[new Date().getDay()];
  let services;
  if (location.services) {
    services = JSON.parse(location.services);
  }

  let customTemplateJSX;
  if (props.template) {
    const templateContext = {
      location,
      todayDayName,
      services,
      distance: roundedDistance,
    };
    customTemplateJSX = (
      <CustomTemplate template={props.template} context={templateContext} />
    );
  }

  let locationNameJSX;
  if (location.location_name) {
    locationNameJSX = <div className="sb-location-name" role="heading" aria-level="5">{location.location_name}</div>;
  }

  const defaultLocationDetail = (
    <>
      {locationNameJSX}
      <div className="sb-location-distance" aria-label={i18n.t('distance')}>{roundedDistance} {distanceUnit}</div>
      <div className="sb-location-address" aria-label={i18n.t('streetAddress')}>{location.street} {location.street2}<br/>{location.city}, {location.state} {location.postal_code}</div>
      <div className="sb-location-phone"><a href={`tel:${location.phonemap_e164.phone}`} aria-label={i18n.t('phoneNumber')}>{location.phonemap.phone}</a></div>
      <div className="sb-location-links">
        <span className="sb-location-link sb-location-link-view-location">
          <a href={location.location_url} rel="noopener noreferrer" aria-label={i18n.t('locationLink')}>
            <Translation>{(t) => t('View Location') }</Translation>
          </a>
        </span>
        <span className="sb-location-link sb-location-link-get-directions">
          <a href={`https://www.google.com/maps/dir/?api=1&destination=${location.formatted_address}`} aria-label={i18n.t('directionsLink')} rel="noopener noreferrer" target="_blank">
            <Translation>{(t) => t('Get Directions') }</Translation>
          </a>
        </span>
      </div>
    </>
  );

  return (
    <div className="sb-location-infowindow">{customTemplateJSX || defaultLocationDetail}</div>
  );
};

LocationInfoWindow.propTypes = {
  location: PropTypes.object,
  template: PropTypes.func,
};

export default LocationInfoWindow;
